import { render, staticRenderFns } from "./FarmHealth.vue?vue&type=template&id=84e8d2ea&"
import script from "./FarmHealth.vue?vue&type=script&lang=js&"
export * from "./FarmHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports